import {AfterViewInit, Component} from '@angular/core';
import {LayoutManagerService} from '../../layout-manager.service';


@Component({
  selector: 'app-partners-content',
  templateUrl: './partners-content.component.html',
  styleUrls: ['./partners-content.component.css']
})
export class PartnersContentComponent implements AfterViewInit {

  constructor(
    private layoutManager: LayoutManagerService
  ) {
    //console.log(layoutManager.innerWidth)
    window.scroll(0,0)
  }

  redirectGrouptaders() {
    window.open("https://www.grouptraders.it", "_blank");
  }

  redirectKlimex() {
    window.open("https://www.grouptraders.it/BrokerKlimex", "_blank");
  }

  ngAfterViewInit() {


  }

}
